import styled from 'styled-components';
import { useNavigate } from 'react-router-dom';
import Modal from './Modal';
import Button from './Button';
import { PiCrownSimpleFill } from "react-icons/pi";

const Content = styled.div`
  text-align: center;
  padding: ${({ theme }) => theme.spacing.lg} 0;
`;

const Title = styled.h2`
  margin-bottom: ${({ theme }) => theme.spacing.lg};
  color: ${({ theme }) => theme.colors.text};
`;

const Message = styled.p`
  margin-bottom: ${({ theme }) => theme.spacing.xl};
  color: ${({ theme }) => theme.colors.text};
  line-height: 1.5;
`;

const LimitInfo = styled.div`
  background: ${({ theme }) => `${theme.colors.primary}10`};
  padding: ${({ theme }) => theme.spacing.md};
  border-radius: 8px;
  margin-bottom: ${({ theme }) => theme.spacing.xl};
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: ${({ theme }) => theme.spacing.md};
  justify-content: center;
`;

const UpgradeButton = styled(Button)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing.sm};
  
  svg {
    width: 18px;
    height: 18px;
  }
`;

const UsageLimitModal = ({ isOpen, onClose, type }) => {
  const navigate = useNavigate();

  const getLimitMessage = () => {
    switch (type) {
      case 'rooms':
        return {
          title: 'Room Limit Reached',
          message: 'You\'ve reached the maximum number of rooms (2) allowed on the free plan.',
          limit: '2 rooms'
        };
      case 'bins':
        return {
          title: 'Bin Limit Reached',
          message: 'You\'ve reached the maximum number of bins (5) allowed per room on the free plan.',
          limit: '5 bins per room'
        };
      default:
        return {
          title: 'Usage Limit Reached',
          message: 'You\'ve reached a usage limit on the free plan.',
          limit: 'Limited usage'
        };
    }
  };

  const { title, message, limit } = getLimitMessage();

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <Content>
        <Title>{title}</Title>
        <Message>{message}</Message>
        <LimitInfo>
          <p>Free Plan Limit: {limit}</p>
        </LimitInfo>
        <ButtonContainer>
          <Button variant="secondary" onClick={onClose}>
            Cancel
          </Button>
          <UpgradeButton
            variant="primary"
            onClick={() => {
              onClose();
              navigate('/pricing');
            }}
          >
            <PiCrownSimpleFill />
            Upgrade to Premium
          </UpgradeButton>
        </ButtonContainer>
      </Content>
    </Modal>
  );
};

export default UsageLimitModal; 